import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2100Model } from './kymw2100.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FlexGrid, CellRangeEventArgs } from '@grapecity/wijmo.grid';
import { Point } from '@grapecity/wijmo';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { CatalogLockService } from '../../../commons/kymw00/api-services/catalog-lock.service';

import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CoopCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { GetCatalogProgressOfMediumService } from './api-services/get-catalog-progress-of-medium.service';
import { GetOrderNumListService } from './api-services/get-order-num-list.service';
import { UpdateIndiscriminatelyOrderNumService } from './api-services/update-indiscriminately-order-num.service';
import { UpdateIndividuallyOrderNumService } from './api-services/update-individually-order-num.service';
import { OrderNumListModel } from './vo/order-num-list.model';
import { SearchConditionOfOrderNumModel } from './vo/search-condition-of-order-num.model';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { EventArgs } from '@grapecity/wijmo';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { CheckboxLabelComponent } from 'src/app/commons/kymw02/checkbox-label/checkbox-label.component';

/**
 * 注文コード設定画面を管理するクラス
 *
 * @export KYMW2100Component
 * @class KYMW2100Component
 */
@Component({
  selector: 'app-kymw2100',
  templateUrl: 'kymw2100.component.html',
  styleUrls: ['kymw2100.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW2100Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;
  public kymw2100Model: KYMW2100Model = new KYMW2100Model();

  @ViewChild('dtg_OrderNumList', { static: true }) dtg_OrderNumList: FlexGrid;
  @ViewChild('txt_OrderCode', { static: true }) txt_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_CoopCode', { static: true }) cmb_CoopCode: CoopCodeComboBoxComponent;
  @ViewChild('txt_PCode', { static: true }) txt_PCode: ElementRef;
  @ViewChild('txt_OrderNumFrom', { static: true }) txt_OrderNumFrom: ElementRef;
  @ViewChild('txt_OrderNumTo', { static: true }) txt_OrderNumTo: ElementRef;
  @ViewChild('txt_PageNumFrom', { static: true }) txt_PageNumFrom: ElementRef;
  @ViewChild('txt_PageNumTo', { static: true }) txt_PageNumTo: ElementRef;
  @ViewChild('btn_Numbering', { static: true }) btn_Numbering: ElementRef;
  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  @ViewChild('btn_Set', { static: true }) btn_Set: ElementRef;
  @ViewChild('btn_Reset', { static: true }) btn_Reset: ElementRef;
  @ViewChild('txt_AvailableOrderNumFrom', { static: true }) txt_AvailableOrderNumFrom: ElementRef;
  @ViewChild('txt_AvailableOrderNumTo', { static: true }) txt_AvailableOrderNumTo: ElementRef;
  @ViewChild('chb_UnnumberedOnlyFlg', { static: true }) chb_UnnumberedOnlyFlg: CheckboxLabelComponent;

  /**
   *Creates an instance of KYMW2100Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {CatalogLockService} catalogLockServiceSub
   * @param {GetCatalogProgressOfMediumService} getCatalogProgressOfMediumService
   * @param {GetOrderNumListService} getOrderNumListService
   * @param {UpdateIndiscriminatelyOrderNumService} updateIndiscriminatelyOrderNumService
   * @param {UpdateIndividuallyOrderNumService} updateIndividuallyOrderNumService
   * @param {ElementRef} elementRef
   * @param {PlessHttp} plessHttp
   * @memberof KYMW2100Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private catalogLockServiceSub: CatalogLockService,
    private getCatalogProgressOfMediumService: GetCatalogProgressOfMediumService,
    private getOrderNumListService: GetOrderNumListService,
    private updateIndiscriminatelyOrderNumService: UpdateIndiscriminatelyOrderNumService,
    private updateIndividuallyOrderNumService: UpdateIndividuallyOrderNumService,
    private elementRef: ElementRef,
    private plessHttp: PlessHttp,
  ) {
    super(kymw00Model);

  }

  /**
   * 更新可能/閲覧モード
   * 'true'：閲覧のみ　　"false"：更新可能
   */
  private readOnly: string;

  /**
   * 検索条件VO
   */
  private searchConditionOfOrderNumVO: SearchConditionOfOrderNumModel;

  /**
   * 注文コード一覧VO
   */
  private orderNumListVO: OrderNumListModel;


  /**
   * 初期処理
   *
   * @memberof KYMW2100Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2100';
    this.kymw2100Model.kymw2100Component = this;
    this.catalogLockService = this.catalogLockServiceSub;

    // 更新可能/閲覧モードを取得
    if (this.kymw00Model.kymw1001Model.formReadOnlyMode.has(this.componentName) === true) {
      this.readOnly = this.kymw00Model.kymw1001Model.formReadOnlyMode.get(this.componentName).toString();
    } else {
      this.readOnly = this.kymw00Model.kymw1001Model.topFuncReadOnlyMode.toString();
    }

    // データグリッドの編集可否を設定
    if (this.readOnly === 'true') {
      this.kymw2100Model.readOnlyOrderNum = true;
    } else {
      this.kymw2100Model.readOnlyOrderNum = false;
    }

    // チェックボックス「注文コードが未付番の商品のみ付番」を初期化
    if (this.readOnly === 'true') {
      this.kymw2100Model.unnumberedOnlyFlg = false;
    } else {
      this.kymw2100Model.unnumberedOnlyFlg = true;
    }

    // 編集完了時
    this.dtg_OrderNumList.cellEditEnded.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      // ESCキーによるキャンセル時はe.dataがundefined、DeleteキーやBackSpaceキー押下時はe.dataが
      // KeyboardEventになるので、入力完了時のみ対応する
      if (typeof e.data === 'string') {
        s.selectedItems[0].OrderNum = e.data;
      }
      this.eventPagenationDetail_ITEM_FOCUS_OUTHandler();
    });

    // 編集終了時
    this.dtg_OrderNumList.cellEditEnding.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (e.cancel && e.cancel === true) {
        // ESCキー押下時は値を元に戻す
        s.setCellData(e.row, e.col, s.activeEditor.value);
      }
    });

    // 貼付け完了時
    this.dtg_OrderNumList.pastedCell.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      // フォーカスアウト時の処理を呼び出す
      this.eventPagenationDetail_ITEM_FOCUS_OUTHandler();
    });

    // // ボタン「設定」、「リセット」の活性状態を設定
    this.plessEnabledSetting();

    // グリッドの初期選択行はなしとする
    this.dtg_OrderNumList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_OrderNumList.select(-1, -1);
    });

    // フォーカス
    this.txt_OrderCode.setFocus();
  }

  /**
   * テキスト入力「受注コード」チェンジイベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW2100Component
   */
  public eventOrderCode_CHANGEHandler(e: Event): void {
    // 媒体、フェーズのリストをクリア
    this.kymw2100Model.clearMediumTypeList();
    this.setCoopCodeEnabled();
    // ボタン「一括付番」の活性状態を設定
    this.setNumberingButtonEnabled();
    // ボタン「検索」の活性状態を設定
    this.setSearchButtonEnabled();
    // 注文コード一覧をクリア
    this.kymw2100Model.clearOrderNumList();
    this.setSetButtonEnabled();

    // マスタに存在する受注コードを入力時、媒体、フェーズのリストを取得
    if (!PlessViewUtilsSub.isEmpty(this.txt_OrderCode.selectedCatalogID)) {
      // VO設定
      const vo: SearchConditionOfOrderNumModel = new SearchConditionOfOrderNumModel();

      // 受注コード
      vo.OrderCode = this.kymw2100Model.orderCode;

      // 媒体情報取得(API取得)
      this.getCatalogProgressOfMediumService.execute(this.kymw2100Model, vo);
    }
  }

  /**
   * コンボボックス「媒体」チェンジイベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW2100Component
   */
  public eventMediumType_CHANGEHandler(e: Event): void {
    // 対応する「フェーズ」を表示
    this.kymw2100Model.setPhase(this.kymw2100Model.mediumType);

    // ボタン「一括付番」の活性状態を設定
    this.setNumberingButtonEnabled();
    // ボタン「検索」の活性状態を設定
    this.setSearchButtonEnabled();
    // 会員生協の活性状態を設定
    this.setCoopCodeEnabled();
    // 検索条件(任意)入力エリアの活性状態を設定
    this.setOptionalSearchConditionEnabled();
    // チェックボックス「注文コードが未付番の商品のみ」の活性制御
    this.setUnnumberedOnlyFlgEnabled();
    // 注文コード一覧をクリア
    this.kymw2100Model.clearOrderNumList();
    this.setSetButtonEnabled();

    // 企画確定時はメッセージを表示
    if (!PlessViewUtilsSub.isEmpty(this.txt_OrderCode.selectedCatalogID) &&
      (!PlessViewUtilsSub.isEmpty(this.kymw2100Model.mediumType))) {
      // フェーズをチェック
      if (Number(this.kymw2100Model.progressWorkNum) >= 7) {
        this.dialogService.openAlertGetMessage('E0149');
      }
    }
  }

  /**
   * 検索条件(任意)入力エリアの活性状態を設定
   */
  private setOptionalSearchConditionEnabled() {
    if (!this.kymw2100Model.isRequiredCoop()) {
      this.enableOptionalSearchCondition();
      return;
    }

    if (this.cmb_CoopCode.selectedIndex > 1) {
      // 各生協を選択時は、検索条件(任意)入力エリアを活性にする
      this.enableOptionalSearchCondition();
    } else {
      // 未選択、「全生協」選択時は、検索条件(任意)入力エリアを非活性にする
      this.disableOptionalSearchCondition();
    }
  }

  /**
   * コンボボックス「会員生協」チェンジイベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW2100Component
   */
  public eventCoopCode_CHANGEHandler(e: Event): void {
    // ボタン「一括付番」の活性状態を設定
    this.setNumberingButtonEnabled();
    // ボタン「検索」の活性状態を設定
    this.setSearchButtonEnabled();
    // 注文コード一覧をクリア
    this.kymw2100Model.clearOrderNumList();
    this.setSetButtonEnabled();

    if (this.cmb_CoopCode.selectedIndex > 1) {
      // 各生協を選択時は、検索条件(任意)入力エリアを活性にする
      this.enableOptionalSearchCondition();
    } else {
      // 未選択、「全生協」選択時は、検索条件(任意)入力エリアを非活性にする
      this.disableOptionalSearchCondition();
    }

    // チェックボックス「注文コードが未付番の商品のみ」の活性制御
    this.setUnnumberedOnlyFlgEnabled();
  }

  /**
   * ボタン「一括付番」クリックイベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW2100Component
   */
  public eventNumbering_CLICKHandler(e: Event): void {
    // VO設定
    const vo: SearchConditionOfOrderNumModel = new SearchConditionOfOrderNumModel();

    // 受注コード
    vo.OrderCode = this.kymw2100Model.orderCode;
    // 媒体区分
    vo.MediumType = this.kymw2100Model.mediumType;
    // 生協コード
    vo.CoopCode = this.kymw2100Model.coopCode;
    // 使用注文コード(From)
    vo.AvailableOrderNumFrom = this.kymw2100Model.availableOrderNumFrom;
    // 使用注文コード(To)
    vo.AvailableOrderNumTo = this.kymw2100Model.availableOrderNumTo;
    // 未付番のみフラグ
    vo.UnnumberedOnlyFlg = this.kymw2100Model.unnumberedOnlyFlg ? '1' : '0';

    // 確認メッセージのイベントリスナメソッドにVOを渡す為に、インスタンス変数にセットする
    this.searchConditionOfOrderNumVO = vo;

    // 確認メッセージを表示
    this.dialogService.openAlertGetMessage('Q0104', ['注文コード'],
      (detail: number) => {
        this.eventAlert1_CLICKHandler(detail);
      });
  }

  /**
     * チェックボックス「注文コードが未付番の商品のみ付番」チェンジイベントリスナ
     *
     * @memberof KYMW2100Component
     */
  public eventCheckbox_CHANGEHandler(): void {
    if (this.kymw2100Model.unnumberedOnlyFlg) {
      return;
    }

    this.dialogService.openAlertGetMessage('Q0184', [], (closeDetals: PlessAlert) => {
      if (closeDetals === PlessAlert.No) {
        this.kymw2100Model.unnumberedOnlyFlg = true;
      }
    });
  }


  /**
   * 一括付番処理確認メッセージイベントリスナ
   *
   * @param {number} detail
   * @memberof KYMW2100Component
   */
  public eventAlert1_CLICKHandler(detail: number): void {
    if (detail === PlessAlert.Yes) {
      if (PlessViewUtilsSub.isEmpty(this.kymw2100Model.lockedOrderCode)
        || PlessViewUtilsSub.isEmpty(this.kymw2100Model.lockedMediumType)) {
        this.registLockNumbering();
      } else {
        // 前回分のロック情報があれば解除して企画ロックを行う
        this.releaseLockInfoCatalog(
          () => {
            this.registLockNumbering();
          },
          () => {
            this.registLockNumbering();
          }
        );
      }
    }
  }

  /**
   * 一括付番処理時の企画ロック処理を行う
   *
   * @private
   * @memberof KYMW2100Component
   */
  private registLockNumbering(): void {
    // ロック対象のキー項目をManageに保持
    this.kymw2100Model.lockedOrderCode = this.searchConditionOfOrderNumVO.OrderCode;
    this.kymw2100Model.lockedMediumType = this.searchConditionOfOrderNumVO.MediumType;

    // 企画ロック処理を実行
    this.LockUtilForCatalog('REGIST_WITH_FORCE_RELEASE', this.searchConditionOfOrderNumVO.OrderCode,
      this.searchConditionOfOrderNumVO.MediumType,
      () => {
        this.numberingEventAfterLock();
      }, null, null, null, false, false);
  }


  /**
   * 一括付番処理 企画ロック後処理
   *
   * @private
   * @memberof KYMW2100Component
   */
  private numberingEventAfterLock(): void {
    // 注文コード一覧をクリア
    this.kymw2100Model.clearOrderNumList();

    // 検索条件(任意)をクリア
    this.kymw2100Model.clearOptionalFilters();

    // 一括付番処理(API取得)
    this.updateIndiscriminatelyOrderNumService.execute(this.kymw2100Model, this.searchConditionOfOrderNumVO);
  }

  /**
   * ボタン「検索」クリックイベントリスナ
   *
   * @param {Event} e
   * @returns {void}
   * @memberof KYMW2100Component
   */
  public eventSearch_CLICKHandler(e: Event): void {
    // VO設定
    const vo: SearchConditionOfOrderNumModel = new SearchConditionOfOrderNumModel();

    // 受注コード
    vo.OrderCode = this.kymw2100Model.orderCode;
    // 媒体区分
    vo.MediumType = this.kymw2100Model.mediumType;
    // 生協コード
    vo.CoopCode = this.kymw2100Model.coopCode;
    // Ｐコード
    vo.PCode = this.kymw2100Model.pCode;
    // 注文コード(From)
    vo.OrderNumFrom = this.kymw2100Model.orderNumFrom;
    // 注文コード(To)
    vo.OrderNumTo = this.kymw2100Model.orderNumTo;
    // ページ番号(From)
    vo.PageNumFrom = this.kymw2100Model.pageNumFrom;
    // ページ番号(To)
    vo.PageNumTo = this.kymw2100Model.pageNumTo;

    // 入力チェック
    if (!this.inputCheckSearchConditionOfOrderNum(vo)) {
      return;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw2100Model.lockedOrderCode)
      || PlessViewUtilsSub.isEmpty(this.kymw2100Model.lockedMediumType)) {
      this.registLockSearch(vo);
    } else {
      // 前回分の企画ロック情報があれば解除して企画ロックを行う
      this.releaseLockInfoCatalog(
        () => {
          this.registLockSearch(vo);
        },
        () => {
          this.registLockSearch(vo);
        }
      );
    }
  }

  /**
   * 検索時の企画ロック処理を行う
   *
   * @param {SearchConditionOfOrderNumModel} vo
   * @memberof KYMW2100Component
   */
  public registLockSearch(vo: SearchConditionOfOrderNumModel) {
    // ロック対象のキー項目をModelに保持
    this.kymw2100Model.lockedOrderCode = vo.OrderCode;
    this.kymw2100Model.lockedMediumType = vo.MediumType;

    // 企画ロック
    super.LockUtilForCatalog('REGIST_WITH_FORCE_RELEASE', vo.OrderCode, vo.MediumType,
      () => {
        if (Number(this.kymw2100Model.progressWorkNum) >= 7) {
          this.kymw2100Model.readOnlyOrderNumList = true;
        } else {
          this.kymw2100Model.readOnlyOrderNumList = false;
        }
        this.searchEventAfterLock(vo);
      },
      null,
      () => {
        let readOnly = '';
        if (this.kymw00Model.kymw1001Model.formReadOnlyMode.has(this.componentName) === true) {
          readOnly = this.kymw00Model.kymw1001Model.formReadOnlyMode.get(this.componentName).toString();
        } else {
          readOnly = this.kymw00Model.kymw1001Model.topFuncReadOnlyMode.toString();
        }

        if (readOnly !== 'true') {
          // 編集権限ありユーザの場合
          (param: any, result: any) => this.dialogService.openAlertGetMessage('E0141',
            ['[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']'],
            (): void => {
              this.searchEventAfterLock(vo);
              this.kymw2100Model.readOnlyOrderNumList = true;
            }
          );
        } else {
          // 閲覧のみユーザの場合
          this.searchEventAfterLock(vo);
          this.kymw2100Model.readOnlyOrderNumList = true;
        }
      },
      null,
      false,
      false);
  }

  /**
   * 検索処理企画ロック後イベント
   *
   * @private
   * @param {SearchConditionOfOrderNumModel} vo
   * @memberof KYMW2100Component
   */
  private searchEventAfterLock(vo: SearchConditionOfOrderNumModel): void {
    // 注文コード一覧取得(API取得)
    this.getOrderNumListService.execute(this.kymw2100Model, vo);
  }

  /**
   * ボタン「設定」クリックイベントリスナ
   *
   * @private
   * @param {Event} e
   * @returns {void}
   * @memberof KYMW2100Component
   */
  public eventSet_CLICKHandler(e: Event): void {
    // VO設定
    const vo: OrderNumListModel = new OrderNumListModel();

    // 受注コード
    vo.OrderCode = this.kymw2100Model.orderCode;
    // 媒体区分
    vo.MediumType = this.kymw2100Model.mediumType;
    // 生協コード
    vo.CoopCode = this.kymw2100Model.coopCode;
    // 注文コード一覧
    vo.OrderNumVOList = this.kymw2100Model.getChangedOrderNumVOList();

    // 更新対象データが存在しない場合はサーバへリクエストを行わない
    if (PlessViewUtilsSub.isEmptyArray(vo.OrderNumVOList)) {
      return;
    }

    // 確認メッセージのイベントリスナメソッドにVOを渡す為に、インスタンス変数にセットする
    this.orderNumListVO = vo;

    // 確認メッセージを表示
    this.dialogService.openAlertGetMessage('Q0104', ['注文コード'],
      (detail: number) => {
        this.eventAlert2_CLICKHandler(detail);
      });
  }

  /**
   * 設定処理確認メッセージイベントリスナ
   *
   * @private
   * @param {number} detail
   * @memberof KYMW2100Component
   */
  public eventAlert2_CLICKHandler(detail: number): void {
    if (detail === PlessAlert.Yes) {
      // 注文コード設定取得(API取得)
      this.updateIndividuallyOrderNumService.execute(this.kymw2100Model, this.orderNumListVO);
    }
  }

  /**
   * ボタン「リセット」クリックイベントリスナ
   *
   * @param {Event} e
   * @memberof KYMW2100Component
   */
  public eventReset_CLICKHandler(e: Event): void {
    // 注文コードを初期値に戻す
    this.kymw2100Model.resetOrderNumList();
    // 表示を更新
    this.kymw2100Model.refreshOrderNumList();
    // 注文コード一覧の選択行を先頭に表示する
    this.selectRowSelected();
  }

  /**
   * データグリッド「注文コード一覧」の選択行を先頭に表示する。
   *
   * @memberof KYMW2100Component
   */
  public selectRowSelected(): void {
    const selectedRowCount = this.dtg_OrderNumList.selectedRows.length - 1;
    if (selectedRowCount > -1) {
      // 選択された行を取得
      const selectedRows: any = this.dtg_OrderNumList.selectedRows[selectedRowCount];
      const maxRowIndex: number = selectedRows.index;
      // スクロール位置を設定
      const scr: any = this.dtg_OrderNumList.cells.getCellBoundingRect(maxRowIndex, 0, true);
      this.dtg_OrderNumList.scrollPosition = new Point(this.dtg_OrderNumList.scrollPosition.x, -scr.top);
      this.dtg_OrderNumList.refresh(false);
    }
  }

  /**
   * データグリッド「注文コード一覧」アイテムフォーカスアウトイベントリスナ
   *
   * @returns {void}
   * @memberof KYMW2100Component
   */
  public eventPagenationDetail_ITEM_FOCUS_OUTHandler(): void {
    if (this.kymw2100Model.readOnlyOrderNumList === true) {
      return;
    }
    // 編集した行の「ステータス」を設定
    this.kymw2100Model.setStatusOrderNumList(this.dtg_OrderNumList.selectedRows[0].index);
  }

  /**
   * ボタン「終了」クリック
   *
   * @param {Event} e
   * @memberof KYMW2100Component
   */
  canDeactivate(): CanDeactivateType {
    this.releaseLockInfoCatalog();
    return true;
  }

  /**
   * ボタン「一括付番」の活性状態を設定する。
   */
  private setNumberingButtonEnabled(): void {

    // 会員生協が入力されていなくてもボタン活性にする注文コード一括付番パターンリスト
    const allowOrderNumSettingPatterns: Array<string> = ["04", "07", "08", "09"];
    
    // 受注コード、媒体、会員生協がすべて入力されている場合のみ活性にする
    if ((!PlessViewUtilsSub.isEmpty(this.txt_OrderCode.selectedCatalogID)) &&
      (!PlessViewUtilsSub.isEmpty(this.kymw2100Model.mediumType)) &&
      (this.cmb_CoopCode.selectedIndex > 0 || allowOrderNumSettingPatterns.includes(this.kymw2100Model.orderNumSettingPattern))
      ) {
      // フェーズをチェック
      if (Number(this.kymw2100Model.progressWorkNum) >= 7) {
        this.plessEnabled(this.btn_Numbering, false);
      } else {
        this.plessEnabled(this.btn_Numbering, true);
      }
    } else {
      this.plessEnabled(this.btn_Numbering, false);
    }

    // 一括付番パターン"00"の場合、ボタン非活性にする
    if (this.kymw2100Model.orderNumSettingPattern === "00") {
      this.plessEnabled(this.btn_Numbering, false);
    }
  }

  /**
   * ボタン「検索」の活性状態を設定する。
   *
   * @private
   * @memberof KYMW2100Component
   */
  private setSearchButtonEnabled(): void {
    // 受注コード、媒体、会員生協(全生協以外)がすべて入力されている場合のみ活性にする
    // 注文コード一括付番パターンが"04","07","08","09"の時は受注コード、媒体区分が入力されていれば活性
    if (((!PlessViewUtilsSub.isEmpty(this.txt_OrderCode.selectedCatalogID)) &&
      (!PlessViewUtilsSub.isEmpty(this.kymw2100Model.mediumType)) &&
      (this.cmb_CoopCode.selectedIndex > 1)) || ((!PlessViewUtilsSub.isEmpty(this.txt_OrderCode.selectedCatalogID)) &&
        (!PlessViewUtilsSub.isEmpty(this.kymw2100Model.mediumType)) &&
        ((this.kymw2100Model.orderNumSettingPattern === "04") ||
          (this.kymw2100Model.orderNumSettingPattern === "07") ||
          (this.kymw2100Model.orderNumSettingPattern === "08") ||
          (this.kymw2100Model.orderNumSettingPattern === "09")))
    ) {
      this.plessEnabled(this.btn_Search, true);
    } else {
      this.plessEnabled(this.btn_Search, false);
    }
  }

  /**
   * 会員生協の入力エリアの活性状態を設定する
   * 
   * @private
   * @memberof KYMW2100Component
   */
  private setCoopCodeEnabled(): void {
    // 媒体区分の注文コード設定一括付番パターンが"04","07","08","09"非活性にする
    if ((!PlessViewUtilsSub.isEmpty(this.txt_OrderCode.selectedCatalogID)) &&
      (!PlessViewUtilsSub.isEmpty(this.kymw2100Model.mediumType)) &&
      ((this.kymw2100Model.orderNumSettingPattern === "04") ||
        (this.kymw2100Model.orderNumSettingPattern === "07") ||
        (this.kymw2100Model.orderNumSettingPattern === "08") ||
        (this.kymw2100Model.orderNumSettingPattern === "09"))
    ) {
      this.plessEnabled(this.cmb_CoopCode, false);
      this.kymw2100Model.coopCode = '';
    } else {
      this.plessEnabled(this.cmb_CoopCode, true);
    }
  }
  /**
   * 検索条件（任意）の入力エリアを活性にする
   *
   * @private
   * @memberof KYMW2100Component
   */
  private enableOptionalSearchCondition(): void {
    this.plessEnabledOptionalSerchCondition(true);
  }

  /**
   * 検索条件（任意）の入力エリアを非活性にする
   *
   * @private
   * @memberof KYMW2100Component
   */
  private disableOptionalSearchCondition(): void {
    this.plessEnabledOptionalSerchCondition(false);
  }

  /**
   * 検索条件（任意）の入力エリアのplessEnabledの設定を行う
   *
   * @private
   * @param {boolean} enabled
   * @memberof KYMW2100Component
   */
  private plessEnabledOptionalSerchCondition(enabled: boolean): void {
    this.plessEnabled(this.txt_PCode, enabled);
    this.plessEnabled(this.txt_OrderNumFrom, enabled);
    this.plessEnabled(this.txt_OrderNumTo, enabled);
    if (this.kymw2100Model.orderNumSettingPattern === "01") {
      this.plessEnabled(this.txt_PageNumFrom, enabled);
      this.plessEnabled(this.txt_PageNumTo, enabled);
    } else {
      this.plessEnabled(this.txt_PageNumFrom, false);
      this.plessEnabled(this.txt_PageNumTo, false);
    }
  }

  /**
   * ボタン「設定」、「リセット」の活性状態を設定する
   *
   * @memberof KYMW2100Component
   */
  public setSetButtonEnabled(): void {
    // 注文コード一覧に１件以上表示している場合のみ活性にする
    if (this.kymw2100Model.getOrderNumListCount() > 0) {
      this.plessEnabled(this.btn_Set, true);
      this.plessEnabled(this.btn_Reset, true);
    } else {
      this.plessEnabled(this.btn_Set, false);
      this.plessEnabled(this.btn_Reset, false);
    }
    // 企画が確定済みの場合は非活性とする
    if (this.kymw2100Model.mediumTypeList != null
      && Number(this.kymw2100Model.progressWorkNum) >= 7) {
      this.plessEnabled(this.btn_Set, false);
      this.plessEnabled(this.btn_Reset, false);
    }
  }

  /**
   * データグリッド「注文コード一覧」を最新の情報に更新する
   *
   * @returns {void}
   * @memberof KYMW2100Component
   */
  public reloadOrderNumList(): void {
    // VO設定
    const vo: SearchConditionOfOrderNumModel = this.kymw2100Model.getSearchConditionOfOrderNumVO();

    // 取得条件チェック
    if (PlessViewUtilsSub.isEmpty(vo.OrderCode)) {
      // 注文コード一覧の取得処理が１度も行われていない場合は、取得処理を行わない
      return;
    }

    // 注文コード一覧取得(API取得)
    this.getOrderNumListService.execute(this.kymw2100Model, vo);
  }

  /**
   * 検索条件の入力チェック
   *
   * @private
   * @param {SearchConditionOfOrderNumModel} vo サーバへのリクエストデータ
   * @returns {Boolean} true:OK false:NG
   * @memberof KYMW2100Component
   */
  private inputCheckSearchConditionOfOrderNum(vo: SearchConditionOfOrderNumModel): boolean {
    // 「注文コード」チェック（From 、及び TO の両方が指定された場合のみ）
    if ((!PlessViewUtilsSub.isEmpty(vo.OrderNumFrom)) && (!PlessViewUtilsSub.isEmpty(vo.OrderNumTo))) {
      if (Number(vo.OrderNumFrom) > Number(vo.OrderNumTo)) {
        this.dialogService.openAlertGetMessage('E0123', ['注文コード']);
        return false;
      }
    }

    // 「ページ」チェック（From 、及び TO の両方が指定された場合のみ）
    if ((!PlessViewUtilsSub.isEmpty(vo.PageNumFrom)) && (!PlessViewUtilsSub.isEmpty(vo.PageNumTo))) {
      if (Number(vo.PageNumFrom) > Number(vo.PageNumTo)) {
        this.dialogService.openAlertGetMessage('E0123', ['ページ']);
        return false;
      }
    }

    return true;
  }

  /**
   * 企画ロック情報を解除する
   *
   * @param {Function} [successFunc=null]
   * @param {Function} [faultFunc=null]
   * @memberof KYMW2100Component
   */
  public releaseLockInfoCatalog(successFunc: Function = null, faultFunc: Function = null): void {
    this.LockUtilForCatalog('RELEASE', this.kymw2100Model.lockedOrderCode, this.kymw2100Model.lockedMediumType,
      successFunc ? () => successFunc() : null, null, faultFunc ? () => faultFunc() : null, null, false, false);
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW0800Component
   */
  plessEnabledSetting() {
    setTimeout(() => {
      // ボタン「一括付番」の活性状態を設定
      this.setNumberingButtonEnabled();
      // ボタン「検索」の活性状態を設定
      this.setSearchButtonEnabled();
      // 未選択、「全生協」選択時は、検索条件(任意)入力エリアを非活性にする
      this.disableOptionalSearchCondition();
      // ボタン「設定」、「リセット」の活性状態を設定
      this.setSetButtonEnabled();
      // 会員生協の活性状態を設定
      this.setCoopCodeEnabled();
    });
  }

  /**
   * チェックボックス「注文コードが未付番の商品のみ」の活性状態を設定する
   * 
   * @private
   * @memberof KYMW2100Component
   */
  private setUnnumberedOnlyFlgEnabled(): void {
    // 会員生協が単協 かつ 選択された媒体の注文コード設定一括付番パターンが"02"、"03"、"06"の場合、
    // チェックが付いた状態で「Disable」、その他の場合は「Enable」
    let disabledOrderNumSettingPatternList = ["02", "03", "06"];
    let isDisabledUnnumberedOnlyFlg: boolean = this.cmb_CoopCode.selectedIndex > 1 && 
      disabledOrderNumSettingPatternList.includes(this.kymw2100Model.orderNumSettingPattern);
    
    this.plessEnabled(this.chb_UnnumberedOnlyFlg, !isDisabledUnnumberedOnlyFlg);
    if (isDisabledUnnumberedOnlyFlg) this.kymw2100Model.unnumberedOnlyFlg = true;
  }
}
